import { decodeJwt } from 'jose'

import type { MapToken } from '../types'

export function parseToken(token: string): MapToken {
	try {
		const decoded = decodeJwt(token) as MapToken

		if (decoded.aud !== 'map-embed') {
			throw new Error('Invalid audience')
		}

		if (decoded.exp && decoded.exp * 1000 < Date.now()) {
			throw new Error('Token expired')
		}

		return decoded
	} catch (err: any) {
		throw new Error(`Invalid JWT: ${err.message}`)
	}
}
